import React from 'react';
import Chart from './Chart';

const LineChart = (props) => <Chart type="line" {...props} />;

export default LineChart;
